/* 
*   Возвращает признак того, что текущий URL принадлежит сравниваемой URL-группе (секции).
*   Не чувствителен к регистру.
*
*   /url        - true
*   /URL        - true
*   /url/       - true
*   /url/anyurl - true 
*/

export function compareURLSection(currentURL: string, compareURL: string): boolean {
    const REGEXP_COMPARE_URL = new RegExp(`^${compareURL}$|${compareURL}(?=(/.*))`, 'i');
    return REGEXP_COMPARE_URL.test(currentURL);
}